
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const RETRIEVE_TOKEN = "RETRIEVE_TOKEN";
export const CHANGE_COMPANY = 'CHANGE_COMPANY';
